import { GameGrid } from './GameGrid';

export function SearchResults({ gameIds, allGames }) {
  const games = gameIds.map(id => {
    return allGames.find(game =>  game.id === id)
  })

  return (
    <div className="pt-24 md:pt-15">
      <GameGrid games={games} loadMoreButton={false} smCols="grid-cols-1" />
    </div>
  )
}